module.exports = __webpack_public_path__ + "img/explortaion_example_2.26e2f645.png";